var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-multiple-cms-parts',{model:{value:(_vm.parts),callback:function ($$v) {_vm.parts=$$v},expression:"parts"}})}
var staticRenderFns = []

export { render, staticRenderFns }